import React from "react";
import moment from "moment";

import CommentAvatar from "./CommentAvatar";
import {
  getCommentAuthorName,
  isHtmlComment,
  sanitizeCommentHtml,
} from "./commentUtils";

export default function CommentItem({
  comment,
  itemClassName = "bg-[#EEF0ED] p-4 rounded-[5px] text-gray-600 mb-4",
  dateFormat = "MM/DD/YYYY HH:mm:ss",
  unknownUserLabel = "Unknown User",
}) {
  const authorName =
    getCommentAuthorName(comment) || unknownUserLabel;
  const dateLabel = comment.CommentDate
    ? moment(comment.CommentDate).format(dateFormat)
    : "";

  const body = comment.CommentText || "";
  const showAsHtml = isHtmlComment(body);
  const safeHtml = showAsHtml ? sanitizeCommentHtml(body) : "";

  return (
    <div
      key={comment.CommentID}
      className={itemClassName}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex min-w-0 items-center gap-2">
          <CommentAvatar
            name={authorName}
            src={comment.Avatar}
            size={28}
          />
          <span className="font-semibold text-gray-800 truncate">
            {authorName}
          </span>
        </div>
        <span className="shrink-0 text-sm text-gray-500 whitespace-nowrap">
          {dateLabel}
        </span>
      </div>

      {showAsHtml ? (
        <div
          className="comment-body mt-2 text-sm text-gray-700"
          dangerouslySetInnerHTML={{ __html: safeHtml }}
        />
      ) : (
        <p className="mt-2 whitespace-pre-wrap text-sm text-gray-700">
          {body}
        </p>
      )}
    </div>
  );
}
